var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fehler",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.755,
    height: 118.049,
    viewBox: "0 0 56.755 118.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Fehler .cls-1 {\n        fill: #9ea1a2;\n      }\n\n      #Fehler .cls-2 {\n        fill: #3e4346;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-941.736 -494.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2728",
    "data-name": "Pfad 2728",
    className: "cls-1",
    d: "M980.326,547.252l-5.425-4.66-4.075,6.643-9.886-5.82-9.54,7.77-6.721-4.949a24.225,24.225,0,0,0-2.359,6.163q-.06.289-.115.579A27.271,27.271,0,1,0,995.82,562.99h0c.952-4.807-.392-12.574-2.645-20.894l-3.3-1.234Zm7.874,12.386a7.086,7.086,0,1,1-5.479-8.392l0,0a7.046,7.046,0,0,1,5.494,8.314Z",
    transform: "translate(0 27.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2729",
    "data-name": "Pfad 2729",
    className: "cls-1",
    d: "M943.587,563.873l8.188,1.615L957.1,554.4l11.423,1.059.859-7.748,6.892,1.908,5.916-9.843,3.512-.292c-11.772-13.857-28.279-28.226-28.279-28.226S944.285,545.519,943.587,563.873Z",
    transform: "translate(1.1 8.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2730",
    "data-name": "Pfad 2730",
    className: "cls-2",
    d: "M968.532,561.8c5.929-4.617,7.671-11.485,7.56-18.522.008-4.29-1.178-7.4-3.5-11.391-7.083-11.147-3.955-25.718.539-37.221-.4,11.778-2.372,24.02,4.743,34.113a27.349,27.349,0,0,1,4.174,9.264c2.31,9.537-2.24,23.367-13.519,23.756Z",
    transform: "translate(15.856 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.1e3f79b1d31858913b64c1922fd8a787.svg";
export { ForwardRef as ReactComponent };